import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import List from './routes/List';

const Transfers = ({match}) => (
	<div>
		<Switch>
			<Redirect exact from={`${match.path}/`} to={`${match.path}/list`}/>
			<Route path={`${match.path}/list`} component={ List } />
		</Switch>
	</div>
);

export default Transfers;


// WEBPACK FOOTER //
// ./app/used/transfers/index.js